/* eslint-disable no-param-reassign */
import { formatMessageWithLocale } from '../../../../locales';
export const admonitionTag = [
  'note',
  'tip',
  'info',
  'caution',
  'danger',
  'warning',
  'check',
] as const;

export function isValidAdmonitionTag(name: string): name is (typeof admonitionTag)[number] {
  return admonitionTag.includes(name as any);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function remarkAdmonition(node: any, hast: any, locale: string) {
  const sourceName = (node.name as string).trim().split(' ');
  const nodeName = sourceName.shift() as string;
  const customTitle = sourceName.join(' ');
  node.children.unshift({
    type: 'paragraph',
    data: {
      hProperties: {
        className: ['admonition-title admonition-legacy-title', `admonition-title-${nodeName}`],
      },
    },
    children: [
      {
        type: 'html',
        value: `<span class="admonition-icon" data-markdown-component="x-admonition-icons" data-icon="${nodeName}"></span>`,
      },
      {
        type: 'text',
        value:
          customTitle ||
          node.attributes?.title ||
          formatMessageWithLocale(locale, { id: nodeName }) ||
          '',
      },
    ],
  });
  hast.properties.className = ['markdown-child-root', 'admonition', `admonition-${nodeName}`];
}
